import { SystemStyleObject } from '@chakra-ui/styled-system';

const backgroundSx: (
  expanded: boolean,
  offset: number,
  maxWidth: number
) => SystemStyleObject = (expanded, offset, maxWidth) => ({
  WebkitAppRegion: 'no-drag',
  maxWidth,
  position: 'absolute',
  transition: 'right 0.4s, width 0.4s',
  transitionTimingFunction: 'ease-in-out',
  left: 0,
  mr: 6,
  pr: 8,
  width: 9,
  height: 9,
  alignItems: 'center',
  borderRadius: '4px',
  bg: 'M.30',
  _focusWithin: {
    boxShadow: '0px 0px 8px 0px var(--chakra-colors-B-50)',
  },
  ...(expanded
    ? {
        right: `${offset}%`,
        width: '100%',
      }
    : {}),
});

const searchIconSx: SystemStyleObject = {
  width: '18px',
  height: '18px',
  ml: 2,
  ' path': {
    fill: 'M.50',
  },
};

const inputSx: SystemStyleObject = {
  ml: 2,
  color: 'M.70',
  textOverflow: 'ellipsis',
  '&::placeholder': {
    color: 'M.50',
  },
};

const clearIconSx: SystemStyleObject = {
  width: 'initial',
  height: 'initial',
  color: 'M.50',
  transform: 'translate(-10px, -50%)',
  position: 'absolute',
  right: 0,
  _hover: {
    cursor: 'pointer',
  },
};

export const styles = {
  backgroundSx,
  searchIconSx,
  inputSx,
  clearIconSx,
};
